import { __awaiter, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useContextSelector } from 'use-context-selector';
import useBoolean from '@eduzz/houston-hooks/useBoolean';
import usePromise from '@eduzz/houston-hooks/usePromise';
import Dropdown from './Dropdown';
import useClickOutside from '../../../hooks/useClickOutside';
import useEscapeKey from '../../../hooks/useEscapeKey';
import IconApps from '../../../Icons/Apps';
import styled from '../../../styled';
import Action from '../Action';
import TopbarContext from '../context';
const TopbarApps = React.memo((_a) => {
    var { id, className } = _a, rest = __rest(_a, ["id", "className"]);
    const isSupport = useContextSelector(TopbarContext, context => { var _a, _b; return (_b = (_a = context.user) === null || _a === void 0 ? void 0 : _a.isSupport) !== null && _b !== void 0 ? _b : false; });
    const currentApplication = useContextSelector(TopbarContext, context => context.currentApplication);
    const [openedDropdown, toogleDropdown, , closeDropdown] = useBoolean();
    const wrapperDropdownRef = React.useRef(null);
    const [applications] = usePromise(() => __awaiter(void 0, void 0, void 0, function* () {
        const request = yield fetch('https://eduzz-houston.s3.amazonaws.com/topbar/applications.json');
        const applications = yield request.json();
        return applications.filter(app => {
            if (!app.beta)
                return true;
            if (isSupport)
                return true;
            return app.application === currentApplication;
        });
    }), [currentApplication, isSupport]);
    useClickOutside(wrapperDropdownRef, closeDropdown, []);
    useEscapeKey(() => {
        if (!openedDropdown)
            return;
        closeDropdown();
    }, [openedDropdown]);
    return (_jsxs("div", Object.assign({ id: `hst-topbar-apps${id !== null && id !== void 0 ? id : ''}`, ref: wrapperDropdownRef, className: className }, rest, { children: [_jsx(Action, { icon: _jsx(IconApps, { size: 19 }), active: openedDropdown, onClick: toogleDropdown }), _jsx(Dropdown, { applications: applications, currentApplication: currentApplication, opened: openedDropdown, onClose: closeDropdown })] })));
});
export default styled(TopbarApps, { label: 'hst-topbar-apps' }) `
  width: auto;
  position: relative;
  box-sizing: border-box;
  height: 100%;
`;
